import { DOCUMENT_STATE_EDIT } from '@/common/page_comp/Documents/document.states.js';


export const PRIVATE_FILTER = it => it.accessType === 'PRIVATE';
export const PUBLIC_FILTER = it => it.accessType === 'PUBLIC';


export const documentsInvalidRules = (docs) => {
    if (!docs) return true;

    for (const it of docs) {
        if (it.removed)
            continue;

        if (it.state === DOCUMENT_STATE_EDIT)
            return false;

        if (it.loading || it.loadingError)
            return false;
    }

    return true;
};
export const documentGroupInvalidRules = (groups) => {
    if (!groups) return true;

    for (const it of groups) {
        if (it.removed)
            continue;

        if (!documentsInvalidRules(it.documents))
            return false;
    }

    return true;
};
